import SEO from "../designSystem/SEO";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import SpecialistLendingImage from "../../assets/images/specialist_lending_01.png";
import { ReactComponent as AccessIcon } from "../../assets/icons/capc_icons_90_uk_lenders.svg";
import { ReactComponent as PersonalIcon } from "../../assets/icons/capc_icons_tailored_advice.svg";
import { ReactComponent as ProfessionalIcon } from "../../assets/icons/capc_icons_end-to-end_support.svg";
import Hero from "../designSystem/Hero";

const highlights = [
  {
    title: "Tailored Advice",
    icon: PersonalIcon,
    text: "Specialist guidance for self-employed applicants, high-net-worth individuals, complex income structures and non-standard borrowing requirements.",
  },
  {
    title: "90+ UK Lenders",
    icon: AccessIcon,
    text: "Access to specialist lenders and private banks offering flexible solutions for more complex cases.",
  },
  {
    title: "End-to-End Support",
    icon: ProfessionalIcon,
    text: "From your initial enquiry through to completion, we manage the paperwork, liaise with lenders and keep you informed every step of the way.",
  },
];

const SpecialistLendingPage = () => (
  <main>
    <SEO
      title="Specialist Lending Services"
      description="Expert specialist lending advice for complex income, unusual properties and borrowing needs outside standard lending criteria."
      path="/specialist-lending"
    />
    <Hero wantOverlay={false}>
      <div className="content-container">
        <div className="column gap-m align-center">
          <div className="nav-text text-secondary-1 uppercase">Our services</div>
          <h1 className="text-primary-1 text-center">Specialist Lending</h1>
          <div className="content text-primary-2 text-center">
            Not every mortgage application fits standard lending criteria. If
            your circumstances are more complex, specialist lending can provide
            flexible solutions that traditional lenders may not be able to
            offer.
          </div>
          <PrimaryButtonSmall text="contact us" />
        </div>
      </div>
    </Hero>

    <section className="background-container bg-white">
      <div className="content-container grid2 gap-xxxxxl grid-stretch">
        <img
          src={SpecialistLendingImage}
          alt="Mortgage adviser reviewing a specialist lending application with clients"
          className="hero-image"
        />
        <div className="column gap-l">
          <h3 className="text-primary-2">
            Why Choose CAPC for Specialist Lending?
          </h3>{" "}
          <div className="column gap-m">
            <div className="content text-primary-2">
              At CAPC, we have extensive experience arranging specialist finance
              for clients with a wide range of borrowing needs. With access to
              over 90 UK lenders, including specialist lenders and private
              banks, we can source mortgage solutions designed around your
              individual circumstances.
            </div>
            <div className="content text-primary-2">
           Whether you're self-employed, have multiple income streams, require a large loan, have a complex property purchase or unique financial circumstances, specialist lenders often take a more tailored approach when assessing your application.
            </div>
          </div>
          <div className="body1 text-primary-2">
            The Financial Conduct Authority does not regulate most buy to let
            mortgages.
          </div>
        </div>
      </div>
    </section>

    <section className="background-container bg-primary-2">
      <div className="content-container grid3 gap-xxxxl">
        {highlights.map(({ title, icon: Icon, text }) => (
          <article className="column gap-xl align-center" key={title}>
            <Icon aria-hidden="true" />
            <div className="column gap-m align-center">
              <div className="subtitle-semibold text-white text-center">
                {title}
              </div>
              <div className="content text-white text-center">{text}</div>
            </div>
          </article>
        ))}
      </div>
    </section>
  </main>
);

export default SpecialistLendingPage;
